/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Blog<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  getPosts = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Blog/GetPosts`,
      method: "GET",
      secure: true,
      ...params,
    });

  getPost = (post: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Blog/GetPost/${post}`,
      method: "GET",
      secure: true,
      ...params,
    });
  
}
